/** @format */

import React, { useEffect, useMemo, useState } from 'react'
import * as Styles from './style'
import { useTable, useSortBy, usePagination } from 'react-table'
import { Button } from 'react-bootstrap'
import axios from 'axios'
import Cookies from 'universal-cookie'
import { Input } from 'antd'
import CreateSHGForm from './components/ClfForm/ShgForm'

const cookies = new Cookies()

const SHGs = () => {
  const [vos, setVos] = useState([])
  const [states, setStates] = useState([])
  const [districts, setDistricts] = useState([])
  const [blocks, setBlocks] = useState([])
  const [selectedState, setSelectedState] = useState('')
  const [selectedDistrict, setSelectedDistrict] = useState('')
  const [selectedBlock, setSelectedBlock] = useState('')
  const [search, setSearch] = useState('')
  const [filteredClfs, setFilteredClfs] = useState([])
  const [voMap, setVoMap] = useState([]) // { clfId: [vo1, vo2, ...] }
  const [shgs, setShgs] = useState([])
  const [loading, setLoading] = useState(false)

  const [showClfModal, setShowClfModal] = useState(false)

  const token = cookies.get('access_token')

  const voName =
    new URLSearchParams(window.location.search).get('voName') || ''
  const voId = new URLSearchParams(window.location.search).get('voId') || ''

  //   // Fetch CLFs based on block
  //   const fetchClfs = async blockId => {
  //     try {
  //       setLoading(true)
  //       const res = await axios.get(
  //         process.env.REACT_APP_API_URL + `/api/v1/humblebee/clf/all`,
  //         {
  //           headers: {
  //             Authorization: 'Bearer ' + token,
  //             source: 'humblebee_admin',
  //           },
  //         }
  //       )
  //       setClfs(res.data?.data || [])
  //       setFilteredClfs(res.data?.data || [])
  //       // fetchVosForClfs(res.data?.data || [])
  //       setLoading(false)
  //     } catch (err) {
  //       console.error('Error fetching CLFs', err)
  //     }
  //   }

  const fetchVosForClfs = async () => {
    try {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/v1/humblebee/clf/shgs/all?voId=${voId}`,
          {
            headers: {
              Authorization: 'Bearer ' + token,
              source: 'humblebee_admin',
            },
          }
        )
        setVos(res.data?.data || [])
      } catch (err) {
        console.error('Error fetching SHGs for VO:', voId, err)
      }

      setLoading(false)
    } catch (err) {
      console.error('Error in fetchVosForClfs:', err)
    }
  }

  useEffect(() => {
    const query = search.toLowerCase()
    setFilteredClfs(
      vos.filter(
        clf =>
          clf.name?.toLowerCase().includes(query) ||
          clf.email?.toLowerCase().includes(query) ||
          clf.mobileNumber?.toLowerCase().includes(query)
      )
    )
  }, [search, vos])

  useEffect(() => {
    fetchVosForClfs()
  }, [voId])

  const CLF_COLUMNS = [
    { Header: 'Vo Name', accessor: 'voName' },
    { Header: 'SHG Name', accessor: 'name' },
    {
      Header: 'Created At',
      accessor: 'createdAt',
      Cell: ({ value }) => {
        const date = new Date(value)
        if (isNaN(date)) return '-'
        return date.toLocaleDateString()
      },
    },

    // {
    //   Header: 'Chairman',
    //   accessor: 'chairman',
    //   Cell: ({ value }) => value?.name || '-',
    // },
    // {
    //   Header: 'Secretary',
    //   accessor: 'secretary',
    //   Cell: ({ value }) => value?.name || '-',
    // },
    // {
    //   Header: 'Treasurer',
    //   accessor: 'treasurer',
    //   Cell: ({ value }) => value?.name || '-',
    // },
    // {
    //   Header: 'State',
    //   accessor: 'location.block.state',
    //   Cell: ({ row }) => row.original?.location?.block?.state || '-',
    // },
    // {
    //   Header: 'District',
    //   accessor: 'location.block.district',
    //   Cell: ({ row }) => row.original?.location?.block?.district || '-',
    // },
    // {
    //   Header: 'Block',
    //   accessor: 'location.block.name',
    //   Cell: ({ row }) => row.original?.location?.block?.name || '-',
    // },
  ]

  const columns = useMemo(() => CLF_COLUMNS, [])
  const data = useMemo(() => {
    if (!search.trim()) return vos
    return vos.filter(
      clf =>
        clf.name?.toLowerCase().includes(search.toLowerCase()) ||
        clf.location?.block?.name?.toLowerCase().includes(search.toLowerCase())
    )
  }, [vos, search])

  const tableInstance = useTable({ columns, data }, useSortBy, usePagination)

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    pageCount,
    gotoPage,
    state,
  } = tableInstance
  const { pageIndex } = state

  if (loading) {
    return <div>Loading...</div>
  }

  const findClfByDistrict = clfs => {
    const districtCount = {}

    clfs.forEach(clf => {
      const district = clf.location?.block?.district || 'Unknown'
      if (districtCount[district]) {
        districtCount[district] += 1
      } else {
        districtCount[district] = 1
      }
    })

    return Object.entries(districtCount).map(([district, count]) => (
      <span key={district}>
        {district}: {count} ||{' '}
      </span>
    ))
  }

  return (
    <>
      <Styles.SupplierBox>
        <div className="flex gap-4 mb-4">
          <h3 className="text-2xl font-semibold mb-4">
            SHGs under VO: {voName}
          </h3>
          <Button
            variant="primary"
            onClick={() => setShowClfModal(true)}
            style={{ marginBottom: '20px', cursor: 'pointer' }}
          >
            + Create SHG
          </Button>
          <CreateSHGForm
            showClfModal={showClfModal}
            setShowClfModal={setShowClfModal}
            onSuccess={fetchVosForClfs}
            voName={voName}
            voId={voId}
          />

          {/* Search input */}
          <Input
            type="text"
            placeholder="Search SHGs by name, block..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            className="mb-6"
          />
          <p className="text-gray-600 self-center mt-4 gap-2">
            Total SHGs: {vos?.length}{' '}
            {/* Total VOs: {vos?.length} {" "}
          Total SHGs: {shgs?.length} */}
          </p>

          {/* State dropdown */}
          {/* <select
          value={selectedState}
          onChange={e => {
            setSelectedState(e.target.value)
            setSelectedDistrict('')
            setSelectedBlock('')
          }}
          className="border p-2 rounded"
        >
          <option value="">Select State</option>
          {states.map(s => (
            <option key={s._id} value={s.name}>
              {s.name}
            </option>
          ))}
        </select>

        <select
          value={selectedDistrict}
          onChange={e => {
            setSelectedDistrict(e.target.value)
            setSelectedBlock('')
          }}
          className="border p-2 rounded"
          disabled={!selectedState}
        >
          <option value="">Select District</option>
          {districts.map(d => (
            <option key={d._id} value={d.name}>
              {d.name}
            </option>
          ))}
        </select> */}

          {/* Block dropdown */}
          {/* <select
          value={selectedBlock}
          onChange={e => setSelectedBlock(e.target.value)}
          className="border p-2 rounded"
          disabled={!selectedDistrict}
        >
          <option value="">Select Block</option>
          {blocks.map(b => (
            <option key={b._id} value={b._id}>
              {b.name}
            </option>
          ))}
        </select> */}
        </div>

        <Styles.TableContainer>
          <Styles.Table {...getTableProps()}>
            <Styles.THead>
              {headerGroups.map(headerGroup => (
                <Styles.THeadRow {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(headerColumn => (
                    <Styles.TH
                      {...headerColumn.getHeaderProps(
                        headerColumn.getSortByToggleProps()
                      )}
                    >
                      {headerColumn.render('Header')}
                    </Styles.TH>
                  ))}
                </Styles.THeadRow>
              ))}
            </Styles.THead>

            <Styles.TBody {...getTableBodyProps()}>
              {page.map(row => {
                prepareRow(row)
                return (
                  <Styles.TBodyRow {...row.getRowProps()}>
                    {row.cells.map((cell, i) => (
                      <Styles.TD key={i}>{cell.render('Cell')}</Styles.TD>
                    ))}
                  </Styles.TBodyRow>
                )
              })}
            </Styles.TBody>
          </Styles.Table>
        </Styles.TableContainer>

        <Styles.PaginationmainContainer>
          <span>
            <strong>
              Page {pageIndex + 1} of {pageOptions.length}
            </strong>
          </span>
          <Styles.PaginationDiv>
            <Styles.PaginationButton
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
            >
              {'<<'}
            </Styles.PaginationButton>
            <Styles.PaginationButton
              onClick={previousPage}
              disabled={!canPreviousPage}
            >
              Previous
            </Styles.PaginationButton>
            <Styles.PaginationButton onClick={nextPage} disabled={!canNextPage}>
              Next
            </Styles.PaginationButton>
            <Styles.PaginationButton
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            >
              {'>>'}
            </Styles.PaginationButton>
          </Styles.PaginationDiv>
        </Styles.PaginationmainContainer>
      </Styles.SupplierBox>
    </>
  )
}

export default SHGs
